<template>
    <v-snackbar v-for="message in messages" v-model="message['isVisible']" multi-line :color="message['type']" location="top right">
        {{message['body']}}
        <template v-slot:actions>
            <v-icon icon="mdi-close-circle" @click="message['isVisible'] = false"></v-icon>
        </template>
    </v-snackbar>
</template>
<script lang="ts" setup>
import {ref} from "vue";
import EventManager from '../service/AppEventManagerService';

const messages = ref([]);

EventManager.on('flash-message', (payload) => {
  if (payload['type'] === 'error' || payload['type'] === 'danger') {
    payload['type'] = 'red-lighten-4';
  }
  if (payload['type'] === 'warning') {
    payload['type'] = 'orange-lighten-4';
  }
  if (payload['type'] === 'success') {
    payload['type'] = 'green-lighten-4';
  }
  const o = {
    type: payload['type'], body: payload['body'], duration: payload['duration'], isVisible: false, isPending: true, ts: Date.now()
  };
  messages.value.push(o);
});

setInterval(() => {
    let hasVisible = false;
    for (const i in messages.value) {
        if (messages.value[i].isVisible) {
            hasVisible = true;
        }
        if (messages.value[i].isPending && Date.now() - messages.value[i].ts > 100) {
            messages.value[i].isVisible = true;
            messages.value[i].isPending = false;
        } else {
            if (messages.value[i].isVisible) {
                if (Date.now() - messages.value[i].ts > 5000) {
                    messages.value[i].isVisible = false;
                }
            }
        }
    }
    if (messages.value.length > 100) {
        //@ts-ignore
        messages.value.splice(0, 50);
    }
}, 500)
</script>

<style scoped lang="scss">
:deep(.v-snackbar__content) {
  font-size: 16px;
  font-weight: 450;
}
</style>